<template>
  <!--== Start Footer Area Wrapper ==-->
  <footer class="footer-area">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="widget-item">
            <div class="about-widget">
              <a class="footer-logo" href="https://hgy.hangongyun.com/#/login" target="_blank">
                <img src="@/assets/picture/logo-dark.png" alt="Logo" style="width: 200px;">
              </a>
              <p class="mb-0">
                专业创造价值，服务赢得未来
              </p>
              <ul class="widget-contact-info">
                <li class="info-address">
                  <i class="icofont-location-pin"></i>
                  <a href="#">{{ basicInfo.address }}</a>
                </li>
                <!-- <li class="info-mail">
                  <i class="icofont-email"></i><a :href="'mailto:'+basicInfo.email">{{ basicInfo.email }}</a>
                </li> -->
                <li class="info-phone">
                  <i class="icofont-link"></i><a href="https://hgy.hangongyun.com/#/login" target="_blank">汉工云平台入口</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">
          <nav class="widget-posts">
            <ul class="posts-item d-flex justify-content-between flex-wrap" style="width: 100%">
              <li>
                <a href="/saas"><i class="icon icofont-rounded-double-right"></i>SAAS服务</a>
              </li>
              <!-- <li>
                <a href="/merchant"><i class="icon icofont-rounded-double-right"></i>产业园招商</a>
              </li> -->
              <li>
                <a href="/employment"><i class="icon icofont-rounded-double-right"></i>就业服务</a>
              </li>
              <li>
                <a href="/services/home"><i class="icon icofont-rounded-double-right"></i>人力资源服务</a>
              </li>
              <li>
                <a href="/increase"><i class="icon icofont-rounded-double-right"></i>增值服务</a>
              </li>

              <li>
                <a href="/aboutus"><i class="icon icofont-rounded-double-right"></i>关于汉工云</a>
              </li>
              <!-- <li>
                <a href="/contactus"><i class="icon icofont-rounded-double-right"></i>联系汉工云</a>
              </li> -->
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="row text-center">
          <div class="col-sm-12">
            <div class="widget-copyright">
              <a target="_blank" href="https://beian.miit.gov.cn/">
                版权所有©2023 {{ basicInfo.company_name }} {{ basicInfo.beian_no }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!--== End Footer Area Wrapper ==-->

</template>

<script>
import AOS from 'aos';
//引入swiper
import Swiper from 'swiper';
import {mapState} from "vuex"

export default {
  name: "Footer",
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      basicInfo:state=>state.basicInfo,
    })
  },
  mounted() {

    /*let data = localStorage.getItem("INFO");
    console.log(data)
    if(data){
      this.basicInfo=JSON.parse(data)
    }*/

    require("@/assets/js/modernizr.js");
    require("@/assets/js/jquery-migrate-3.3.2.min.js");
    require("@/assets/js/bootstrap.bundle.min.js");
    require("@/assets/js/jquery-ui.min.js");
    require("@/assets/js/plugincollection.js");
    require("@/assets/js/custom.js");
    this.initAOS();
  },
  methods:{
    initSwiper(){
      var heroSlider = new Swiper(".hero-slider .swiper-container", {
        slidesPerView: 1,
        speed: 600,
        loop: true,
        spaceBetween: 0,
        autoplay: false,
        navigation: {
          nextEl: ".hero-slider .swiper-button-next",
          prevEl: ".hero-slider .swiper-button-prev",
        },
      });

      var serviceSlider = new Swiper(".service-slider-container", {
        slidesPerView: 3,
        speed: 1000,
        loop: true,
        spaceBetween: 30,
        autoplay: false,
        breakpoints: {
          1200: {
            slidesPerView: 3,
            spaceBetween: 84,
          },

          992: {
            slidesPerView: 3,
            spaceBetween: 30,
          },

          768: {
            slidesPerView: 2,
            spaceBetween: 50,
          },

          576: {
            slidesPerView: 2,
            spaceBetween: 30,
          },

          0: {
            slidesPerView: 1,
          },
        },
      });

      var teamSlider = new Swiper(".team-slider-container", {
        slidesPerView: 3,
        speed: 1000,
        loop: true,
        spaceBetween: 30,
        autoplay: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1200: {
            slidesPerView: 3,
          },

          991: {
            slidesPerView: 2,
          },

          767: {
            slidesPerView: 2,
          },

          560: {
            slidesPerView: 2,
          },

          0: {
            slidesPerView: 1,
          },
        },
      });

      var caseSlider = new Swiper(".case-slider-container", {
        slidesPerView: 2,
        speed: 1000,
        loop: true,
        spaceBetween: 30,
        autoplay: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1200: {
            slidesPerView: 2,
          },

          991: {
            slidesPerView: 2,
          },

          767: {
            slidesPerView: 2,
          },

          576: {
            slidesPerView: 2,
          },

          0: {
            slidesPerView: 1,
          },
        },
      });

      var testimonialSlider = new Swiper(".testimonial-slider-container", {
        slidesPerView: 1,
        speed: 1000,
        loop: true,
        spaceBetween: 0,
        effect: "fade",
        fadeEffect: { crossFade: true },
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      var gallerySlider = new Swiper(".department-gallery", {
        slidesPerView: 1,
        speed: 1000,
        loop: true,
        spaceBetween: 10,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      var brandLogoSlider = new Swiper(".brand-logo-slider-container", {
        slidesPerView: 5,
        loop: true,
        speed: 1000,
        spaceBetween: 30,
        autoplay: false,
        breakpoints: {
          1200: {
            slidesPerView: 5,
            spaceBetween: 100,
          },

          992: {
            slidesPerView: 4,
            spaceBetween: 90,
          },

          768: {
            slidesPerView: 3,
            spaceBetween: 110,
          },

          576: {
            slidesPerView: 3,
            spaceBetween: 60,
          },

          380: {
            slidesPerView: 3,
            spaceBetween: 30,
          },

          0: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      });
    },
    initAOS(){
      AOS.init({
        easing: "ease", // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
      });
      this.stylePreloader();
    },
    stylePreloader(){
      $("body").addClass("preloader-deactive");
    }
  }
};
</script>
<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Footer.vue